// export the components
export { default as Layout } from './Layout';
export { default as ArticleListingPage } from './ArticleListingPage';
export { default as PromoListingPage } from './PromoListingPage';
export { default as PromoDetailPageTemplate } from './PromoDetailPageTemplate';
export { default as ArticleDetailPageTemplate } from './ArticleDetailPageTemplate';
export { default as BranchListingPageTemplate } from './BranchListingPageTemplate';
export { default as ContactUsPageTemplate } from './ContactUsPageTemplate';
export { default as ServiceDetailPageTemplate } from './ServiceDetailPageTemplate';
export { default as ServiceListingPageTemplate } from './ServiceListingPageTemplate';
export { default as AuthPageTemplate } from './AuthPageTemplate';
export { default as AccessoriesDetailPageTemplate } from './AccessoriesDetailPageTemplate';
